import { ApplicationError } from "@rocicorp/zero";
import * as Sentry from "@sentry/react";
import { withoutPerRequestDetail } from "../../shared/sentryFingerprint";
import { zeroDefinitionNotFoundDetails } from "../../shared/zeroErrors";

// A mutator failure throws from inside Zero's client, so no first-party frame
// remains for Sentry to group on and every cause collapses into one issue.
export function mutatorErrorFingerprint(
  logMessage: unknown,
  error: ApplicationError
): string[] {
  return [
    "zero-mutator",
    withoutPerRequestDetail(typeof logMessage === "string" ? logMessage : ""),
    withoutPerRequestDetail((error.message.split("\n")[0] ?? "").trim()),
  ];
}

// Demote Zero's error logs to warn to keep transient sync chatter out of
// Sentry; missing definitions are reported from completed results so queries
// and mutations share the same browser-only path.
export const zeroLogger = {
  logLevel: "error" as const,
  logSink: {
    log: (
      level: "error" | "warn" | "info" | "debug",
      context: Record<string, unknown> | undefined,
      ...args: unknown[]
    ) => {
      if (level === "error") {
        const appError = args.find(
          (a): a is ApplicationError => a instanceof ApplicationError
        );
        if (
          appError &&
          (appError.details as { userFacing?: boolean } | undefined)
            ?.userFacing !== true &&
          !zeroDefinitionNotFoundDetails(appError)
        ) {
          Sentry.captureException(appError, {
            tags: { source: "zero-mutator" },
            extra: { zeroContext: context, message: args[0] },
            fingerprint: mutatorErrorFingerprint(args[0], appError),
          });
        }
      }
      console.warn(level, context, ...args);
    },
  },
};
